require("./sitio");
require("bootstrap");
require("@fancyapps/fancybox");

$(document).ready(function () {
    if ($("#modal-promociones").length) {
        $("#modal-promociones").modal("show");

        $("#cerrar-modal-promocion").click(function () {
            $("#modal-promociones").modal("hide");
        });
    }

    $("#proyectos .proyectos-slide").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    // Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.

    $("#como-lo-hacemos .como-lo-hacemos-slide").slick({
        autoplay: false,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('#como-lo-hacemos .next-btn').click(function() {
        $("#como-lo-hacemos .como-lo-hacemos-slide").slick('slickNext');
    });

    $('#como-lo-hacemos .prev-btn').click(function() {
        $("#como-lo-hacemos .como-lo-hacemos-slide").slick('slickPrev');
    });


    $('#proyectos .next-btn').click(function() {
        $("#proyectos .proyectos-slide").slick('slickNext');
    });

    $('[data-fancybox="proyectos"]').fancybox({
        // Otras opciones de configuración aquí
        loop: true, // Habilita el bucle de la galería
        slideShow: {
            autoStart: true, // Inicia la reproducción automática al abrir la galería
            speed: 2000 // Velocidad de reproducción automática en milisegundos (opcional)
        }
    });
});
